
import {
    VuexModule,
    Mutation,
    Action, Module
} from 'vuex-module-decorators'

import { AxiosError, AxiosResponse } from "axios";
import Vue from "vue";
import { NotificationPreferences, SchedulingPreferences, SMSPreferences } from "@/models";
import router from '@/router';
import bus from '../../../src/eventBus'
import http from '@/store/axios'

@Module({ namespaced: true })
class Profile extends VuexModule {

    //STATE
    profileData: any = {};
    isAdmin: boolean = false;
    schedulingPrefData: SchedulingPreferences = new SchedulingPreferences();
    notificationPrefData: NotificationPreferences = new NotificationPreferences();
    smsPrefData: SMSPreferences = new SMSPreferences();
    isImpersonating: boolean = false;
    impersonatingUser: string = '';
    appInsightEventData:any={};
    isStaffManager: boolean = false;
    trainingVideos: any = [];

    @Mutation
    public setAppInsightEventData(profileData: any): void {
        let primarySkill = "";

        if (profileData.staffId > 0 && typeof profileData.skills !== "undefined") {
            for (var i = 0; i < profileData.skills.length; i++) {
                if (profileData.skills[i].primary === true) {
                    primarySkill = profileData.skills[i].description;
                    break;
                }
            }
        }

        this.appInsightEventData = {
            Username: profileData.username,
            TenantName: profileData.tenantName,
            FacilityName: profileData.facilityName,
            COID: profileData.coid,            
            DeptCode: profileData.deptCode,            
            DeptName: profileData.deptName,
            Skill: primarySkill,
            Client: "StaffPortal"
        };
    }

    @Action
    public updateAppInsightEventData(newData: string): void {
        this.context.commit('setAppInsightEventData', newData)
    }
    
    //MUTATIONS
    @Mutation
    setProfileData(payload: any): void {
        this.profileData = payload.newState;

        if (payload.userId.length > 0) {
            this.impersonatingUser = payload.userId;
            this.isImpersonating = true;
            this.isAdmin = true;
        }
        else {
            this.impersonatingUser = '';
            this.isImpersonating = false;

            if(this.profileData.isAdmin == true || this.profileData.isStaffHasAdminAccount == true)
            {
                this.isAdmin = true;
            }
            else{
                this.isAdmin = false;
            }
        }

        bus.$emit("profileLoaded", "");
    }

    @Mutation
    setSchedulingPref(newState: SchedulingPreferences): void {
        this.schedulingPrefData = newState;        
    }

    @Mutation
    setNotificationPref(newState: NotificationPreferences): void {
        this.notificationPrefData = newState;
    }

    @Mutation
    setSMSPref(newState: SMSPreferences): void {
        this.smsPrefData = newState;
    }

    @Mutation
    setSMSPref_AfterActivateMobileNumber(expireDate: Date): void {
        this.smsPrefData.activationCodeExpiresUtc = expireDate;
        this.smsPrefData.validated = false;
        this.smsPrefData.validatedDate = null;
    }

    @Mutation
    setSMSPref_AfterValidateActivationCode(newState: SMSPreferences): void {
        this.smsPrefData.validated = newState.validated;
        this.smsPrefData.validatedDate = newState.validatedDate;
        this.smsPrefData.assignmentCreated = newState.assignmentCreated;
        this.smsPrefData.assignmentModified = newState.assignmentModified;
        this.smsPrefData.assignmentCanceled = newState.assignmentCanceled;
        this.smsPrefData.staffingNeed = newState.staffingNeed;
        this.smsPrefData.staffingNeedCriticalPay = newState.staffingNeedCriticalPay;
    }

    @Mutation
    setWelcomePopupStatus(): void {
        this.profileData.isFirstTimeLogin = true;
    }
    @Mutation
    public setStaffManager(isStaffManager: boolean): void {
        this.isStaffManager = isStaffManager;
    }
    @Mutation
    public setTrainingVideos(result: any): void {
        
        this.trainingVideos = result;
        this.trainingVideos = this.trainingVideos.filter(function(v){
            return v.ApplicationName == 'MyScheduler'
        });
    }

    // ACTIONS
    @Action({ rawError: true })
    public getProfileDetails(username: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/${username}`;
        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                if(res.status === 204 || (!res.data.isAdmin && res.data.isDisabled && ! res.data.useStaffScheduler)) {
                    router.push("/invalidaccount");
                }
                else
                {              
                    let payload = {
                        newState: res.data,
                        userId: username,
                    }

                    this.context.commit("setProfileData", payload);
                    this.context.commit("setAppInsightEventData", payload.newState);
                }
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                router.push('/erroraccount');
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public getSchedulingPrefDetails(username: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/Schedule/${username}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                this.context.commit("setSchedulingPref", res.data);
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                console.log(err);
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public saveSchedulingPrefDetails(payload) {        
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/Schedule/${payload.username}`;

        return http
            .post(apiUrl, payload.schPrefData)
            .then((res: AxiosResponse) => {
                this.context.commit("setSchedulingPref", payload.schPrefData);               
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() }) 
                console.log(err);
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public getSMSPrefDetails(username: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/Sms/${username}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                this.context.commit("setSMSPref", res.data);
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                console.log(err);
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public saveSMSPrefDetails(payload) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/sms/${payload.username}`;

        return http
            .post(apiUrl, payload.smsData)
            .then((res: AxiosResponse) => {
                this.context.commit("setSMSPref", payload.smsData);
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                console.log(err);
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public activateMobileNumber(payload) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/Sms/Activate/${payload.username}?phoneNumber=${payload.phoneNumber}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                this.context.commit("setSMSPref_AfterActivateMobileNumber", res.data);
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                throw err;
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public reactivateMobileNumber(payload) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/Sms/Reactivate/${payload.username}?phoneNumber=${payload.phoneNumber}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                this.context.commit("setSMSPref_AfterActivateMobileNumber", res.data);
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                throw err;
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public validateActivationCode(payload) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/Sms/Validate/${payload.username}?activationCode=${payload.activationCode}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                this.context.commit("setSMSPref_AfterValidateActivationCode", res.data);
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                throw err;
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public getNotificationPrefDetails(username: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/Notification/${username}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                this.context.commit("setNotificationPref", res.data);
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                console.log(err);
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public saveNotificationPrefDetails(payload) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/Notification/${payload.username}`;

        return http
            .post(apiUrl, payload.ntfData)
            .then((res: AxiosResponse) => {
                this.context.commit("setNotificationPref", payload.ntfData);
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                console.log(err);
            });
    }
    
    // ACTIONS
    @Action({ rawError: true })
    public updateWelcomePopupstatus(payload){
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/UpdateWelcomePopupStatus`;

        return http
            .post(apiUrl, payload)
            .then((res: AxiosResponse) => {
                this.context.commit("setWelcomePopupStatus");
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                console.log(err);
            });
    }

     // ACTIONS
     @Action({ rawError: true })
     public checkStaffManager(impersonateUsername: string) {
         const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Profiles/CheckStaffManager/${impersonateUsername}`;
 
         return http
             .get(apiUrl)
             .then((res: AxiosResponse) => {
                 this.context.commit("setStaffManager",res.data);                 
             })
             .catch((err: AxiosError) => {
                 Vue.notify({ type: "error", text: err.toString() })
                 console.log(err);
             });
     }

     // ACTIONS
    @Action({ rawError: true })
    public getTrainingVideos(tenantId:any) {
        if (!tenantId)
        {
            tenantId = this.profileData.tenantId;
        }
        if (tenantId){
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/FacilityConfigs/getTrainingVideos/${tenantId}`;
        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                if(res != null && (res.data != null && res.data != '')){
                    this.context.commit("setTrainingVideos", res.data);
                }
            })
            .catch((err: AxiosError) => {
                Vue.notify({ type: "error", text: err.toString() })
                console.log(err);
            });
        }   
        else{
            return Vue.$net;
        }     
    }
}
export default Profile;
